/**
 * @file index.ts
 */
export { ErrorObject, ErrorType } from './error.interface';
export { ErrorManagerService } from './error-manager/error-manager.service';
